export default __webpack_public_path__ + "images/Drinks-Only.c73bce.jpg";